import React, { useState } from "react";
import SimpleContent from "../../Structure/ModalManager/SimpleContent.js";
import Button from "../../Elements/Button/Button.js";
import LoadingImageElement from "components/Elements/LoadingContainerElement/LoadingImageElement.tsx";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useModal } from "../../../contexts/modalContext/modalContext.js";

import "./ConfirmationModal.scss";

const ConfirmationModal = ({
  confirmTitle,
  confirmText,
  confirmAction,
  yesButtonText = false,
  noButtonNext = false,
}) => {
  const { getTextByKey } = useContent();
  const { closeModal } = useModal();
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    const response = await confirmAction();
    if (response.status) {
      closeModal();
      setLoading(false);
    }
  };

  return (
    <SimpleContent
      title={confirmTitle}
      message={confirmText}
      actionButton={
        loading ? (
          <LoadingImageElement />
        ) : (
          <Button onClick={() => handleConfirm()}>
            {yesButtonText || getTextByKey("yes")}
          </Button>
        )
      }
      exitButton={
        loading ? null : (
          <Button blank onClick={() => closeModal()}>
            {noButtonNext || getTextByKey("no")}
          </Button>
        )
      }
    ></SimpleContent>
  );
};

export default ConfirmationModal;
